"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSingleFileUpload = exports.SingleFileUpload = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var InputContainer_1 = require("../../components/InputContainer");
var classnames_1 = __importDefault(require("classnames"));
var R = __importStar(require("../../utils/ramda"));
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var MDIcon_1 = require("../../components/MDIcon");
require("./SingleFileUpload.css");
require("../Button/Button.css");
var Grid_1 = require("../../components/Grid");
var SingleFileUpload = function (_a) {
  var _b;
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    accept = _a.accept,
    file = _a.file,
    _c = _a.onClear,
    onClear = _c === void 0 ? R.N : _c,
    _d = _a.onChange,
    onChange = _d === void 0 ? R.N : _d,
    inputRef = _a.inputRef,
    _e = _a.buttonText,
    buttonText = _e === void 0 ? "Browse" : _e,
    _f = _a.placeholderText,
    placeholderText = _f === void 0 ? "No file chosen" : _f,
    disabled = _a.disabled,
    readOnly = _a.readOnly,
    restProps = __rest(_a, ["id", "className", "children", "accept", "file", "onClear", "onChange", "inputRef", "buttonText", "placeholderText", "disabled", "readOnly"]);
  var _g = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _g[0];
  var inputId = id || guid;
  var showPlaceholder = R.isNothing(file === null || file === void 0 ? void 0 : file.name);
  var showClearButton = file && !disabled && !readOnly;
  var labelClass = (0, classnames_1.default)("vsx-single-file-upload-text", showPlaceholder && "vsx-single-file-upload-placeholder");
  return (0, jsx_runtime_1.jsxs)(InputContainer_1.InputContainer, __assign({
    className: (0, classnames_1.default)("vsx-single-file-upload", className),
    paddingLeft: "medium",
    childBasis: "100%"
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)("input", {
      ref: inputRef,
      id: inputId,
      type: "file",
      accept: accept,
      disabled: disabled,
      readOnly: readOnly,
      onChange: onChange
    }), (0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
      columns: "auto 1fr auto",
      align: "center",
      gap: "medium"
    }, {
      children: [(0, jsx_runtime_1.jsx)("label", __assign({
        htmlFor: inputId,
        className: "vsx-btn secondary uppercase vsx-single-file-upload-button"
      }, {
        children: buttonText
      })), (0, jsx_runtime_1.jsx)("label", __assign({
        className: labelClass,
        htmlFor: inputId
      }, {
        children: (_b = file === null || file === void 0 ? void 0 : file.name) !== null && _b !== void 0 ? _b : placeholderText
      })), showClearButton ? (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        size: "1.3em",
        icon: "close",
        "aria-label": "close",
        clickable: true,
        onClick: onClear
      }) : null]
    }))]
  }));
};
exports.SingleFileUpload = SingleFileUpload;
var useSingleFileUpload = function () {
  var inputRef = (0, react_1.useRef)(null);
  var _a = __read((0, react_1.useState)(undefined), 2),
    file = _a[0],
    setFile = _a[1];
  var clearInputValue = function () {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  var onChange = function (e) {
    var files = e.currentTarget.files;
    var file = files && files.length ? files[0] : undefined;
    setFile(file);
  };
  var onClear = function () {
    setFile(undefined);
    clearInputValue();
  };
  return {
    inputRef: inputRef,
    file: file,
    onChange: onChange,
    onClear: onClear
  };
};
exports.useSingleFileUpload = useSingleFileUpload;